import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosPagosPagoConfigurarComponent {
  changed = false
  cuentas = {}
  data
  guardando = false
  onClose
  onSave

  constructor (ViaticosPagosPendientesService, ViaticosPagosPagoService, ViaticosPagosPagoPagarService, ViaticosPagosRealizadosService,
               ViaticosCatalgosPagadoraCuentasBancariasService, ViaticosCatalgosColaboradorCuentasBancariasService, $q) {
    this.ViaticosPagosPendientesService = ViaticosPagosPendientesService
    this.ViaticosPagosPagoService = ViaticosPagosPagoService
    this.ViaticosPagosPagoPagarService = ViaticosPagosPagoPagarService
    this.ViaticosPagosRealizadosService = ViaticosPagosRealizadosService
    this.ViaticosCatalgosPagadoraCuentasBancariasService = ViaticosCatalgosPagadoraCuentasBancariasService
    this.ViaticosCatalgosColaboradorCuentasBancariasService = ViaticosCatalgosColaboradorCuentasBancariasService
    this.$q = $q
  }

  $onInit () {
    this.pago = this.data.pago ? this.data.pago : {}
    this.pago.fecha_pago = this.data.pago ? this.data.pago.fecha_pago : new Date()
    this.promise = this.$q.all({
        pagadora_cuentas: this.ViaticosCatalgosPagadoraCuentasBancariasService.get(this.data.id_pagadora),
        colaborador_cuentas: this.ViaticosCatalgosColaboradorCuentasBancariasService.get(this.data.id_proyecto, this.data.id_colaborador),
      })
      .then(({colaborador_cuentas, pagadora_cuentas}) => (this.cuentas = {colaborador: colaborador_cuentas.data, pagadora: pagadora_cuentas.data}))

  }

  getCuentaPagadora (id_cuenta) {
    this.changed = this.pago.id_cuenta_retiro !== id_cuenta
    this.pago.id_cuenta_retiro = id_cuenta
  }

  getCuentaColaborador (cuenta) {
    this.changed = this.pago.banco_cuenta !== cuenta
    this.pago.banco_cuenta = cuenta
  }

  guardar () {
    this.guardando = true
    this.ViaticosPagosPendientesService.post(this.data.folio, this.data.indice, this.pago)
      .then(({data}) => {
        this.changed = false
        this.guardando = false
        this.pago = Object.assign(this.pago, data)
        this.onSave({$event: {detail: this.pago}})
      })
  }

  actualizar () {
    this.guardando = true
    this.ViaticosPagosPagoService.put(this.data.folio, this.data.indice, this.pago)
      .then(({data}) => {
        this.changed = false
        this.guardando = false
        this.pago = Object.assign(this.pago, data)
        this.onSave({$event: {detail: this.pago}})
      })
  }

  pagar () {
    this.guardando = true
    const servicio = this.pago.id_pago ? this.ViaticosPagosPagoPagarService : this.ViaticosPagosRealizadosService
    servicio.post(this.data.folio, this.data.indice, this.pago)
      .then(({data}) => {
        this.changed = false
        this.guardando = false
        this.pago = Object.assign(this.pago, data)
        this.onSave({$event: {detail: this.pago}})
      })
  }

  cancelar () {
    this.onClose()
  }

}

module.component('viaticosPagosPagoConfigurar', {
  controller: ViaticosPagosPagoConfigurarComponent,
  template,
  bindings: {
    data: '<',
    onSave: '&',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/pagos/pago/configurar/component.js